import React from 'react';
import Fetch from '@components/util/Fetch';
import Icon from '@components/shared/icons';
import { logCrmEvent } from '@javascripts/util/eventLogging';
import PropTypes from 'prop-types';
import './styles.scss';

function WelcomeTeamsBanner({ data }) {
  const { dismissPath } = data;

  const handleClick = async () => {
    logCrmEvent('welcome_teams_banner_click');
    await Fetch.post({ url: dismissPath });
    window.location = '/profile/account-settings/team';
  };

  const handleClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    logCrmEvent('welcome_teams_banner_dismiss');
    const banner = document.getElementById('welcome-teams-banner-content');
    banner.style.display = 'none';
    Fetch.post({ url: dismissPath });
  };

  return (
    <div
      id="welcome-teams-banner-content"
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && handleClick()}
    >
      <button
        type="button"
        className="close-welcome-teams-button"
        onClick={handleClose}
      >
        <Icon type="close" />
      </button>

      <span className="welcome-teams-text large-bold-font">
        <Icon type="trophy" />
        Welcome to ReferralExchange Teams! Invite your team now to get started.
      </span>
      <button
        type="button"
        className="profile-edit-button submit"
      >
        Invite Team
      </button>
    </div>
  );
}

WelcomeTeamsBanner.propTypes = {
  data: PropTypes.shape({
    dismissPath: PropTypes.string,
  }).isRequired,
};

export default WelcomeTeamsBanner;
